import { CommonModule } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { DXONgSwiftUiModule } from '@dxo/ng-swift-ui';
import { BenefitsSharedModule } from '@benefits/shared';
import { BenefitsSharedFormsModule } from '@benefits/shared-forms';
import { BenefitsSharedServicesModule } from '@benefits/shared-services';
import { httpErrorInterceptorProviders } from '@benefitsui/app/interceptors/error/http-error.interceptor';
import { environment } from '@benefitsui/environments/environment';
import { AppEnvironment } from '@benefitsui/environments/environment.common';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FooterComponent } from './components/footer/footer.component';
import { HomePageComponent } from './pages/home-page/home-page.component';
import { LoginPageComponent } from './pages/login-page/login-page.component';
import { NavPortalPageComponent } from './pages/nav-portal-page/nav-portal-page.component';
import { GoogleAnalyticsService } from './services/analytics/google-analytics.service';
import { PortalTimeoutModalComponent } from './shared/components/portal-timeout-modal/portal-timeout-modal.component';
import { PortalTimeoutInterceptor } from './shared/interceptors/portal-timeout/portal-timeout.interceptor';
import { ErrorPageComponent } from './pages/error-page/error-page.component';
import { NoAccessPageComponent } from './pages/no-access-page/no-access-page.component';
import { NotFoundPageComponent } from './pages/not-found-page/not-found-page.component';
import { ListPoliciesPageComponent } from './pages/list-policies-page/list-policies-page.component';
import { PolicyOverviewPageComponent } from './pages/policy-overview-page/policy-overview-page.component';
import { windowProvider } from './lib/tokens/window';
import { ReportPageComponent } from './pages/report-page/report-page.component';
import { httpPolicyTokenInterceptorProviders } from './interceptors/policy-token/http-policy-token.interceptor';
import { NoContentPageComponent } from './shared/components/no-content-page/no-content-page.component';
import { DocumentsPageComponent } from './pages/documents/documents-page/documents-page.component';
import { DocumentGroupComponent } from './pages/documents/document-group-page/document-group-page.component';
import { FlagsInterceptor } from './interceptors/flags/flags.interceptor';
import { DocumentsErrorPageComponent } from './shared/components/p8-documents-error-page/error-page.component';
import { BillingPageComponent } from './pages/billing-page/billing-page.component';
import { BillingListComponent } from './pages/billing-page/list/list.component';
import { BillingPaymentComponent } from './pages/billing-page/payment/payment.component';
import { PremiumComponent } from './pages/billing-page/premium/premium.component';
import { GetSortIconColorPipe } from './shared/pipes/getSortIconColor/getSortIconColor.pipe';
import { ScheduleAPageComponent } from './pages/scheduleA-page/scheduleA-page.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ClaimPageComponent } from './pages/claim-page/claim-page.component';
import { EmployeePageComponent } from './pages/employee-page/employee-page.component';
import { EmployeeDetailComponent } from './pages/employee-page/detail/detail.component';
import { ListEmployeeComponent } from './pages/employee-page/list/list.component';
import { AddEmployeeComponent } from './pages/employee-page/add/add.component';
import { LeftNavPortalPageComponent } from './pages/left-nav-portal-page/left-nav-portal-page.component';
import { ClaimDetailsComponent } from './pages/claim-page/details/details.component';
import { CreateClaimComponent } from './pages/claim-page/create/create.component';
import { AcceptencePageComponent } from './shared/components/acceptence-page/acceptence-page.component';
import { AllFormsPageComponent } from './pages/form/forms-page.component';
import { ClaimsFormsPageComponent } from './pages/form/claims-page.component';
import { EmployeeFormsPageComponent } from './pages/form/employee-page.component';
import { TaxFormsPageComponent } from './pages/form/tax-page.component';
import { DashboardPageComponent } from './pages/dashboard-page/dashboard-page.component';
import { FinancialTaxPageComponent } from './pages/financial/tax/tax-page.component';

@NgModule({
  declarations: [
    AcceptencePageComponent,
    AddEmployeeComponent,
    AllFormsPageComponent,
    AppComponent,
    BillingListComponent,
    BillingPageComponent,
    BillingPaymentComponent,
    ClaimDetailsComponent,
    ClaimPageComponent,
    ClaimsFormsPageComponent,
    CreateClaimComponent,
    DashboardPageComponent,
    DocumentGroupComponent,
    DocumentGroupComponent,
    DocumentsErrorPageComponent,
    DocumentsPageComponent,
    EmployeeDetailComponent,
    EmployeeFormsPageComponent,
    EmployeePageComponent,
    ErrorPageComponent,
    FooterComponent,
    FinancialTaxPageComponent,
    GetSortIconColorPipe,
    HomePageComponent,
    LeftNavPortalPageComponent,
    ListEmployeeComponent,
    ListPoliciesPageComponent,
    LoginPageComponent,
    NavPortalPageComponent,
    NoAccessPageComponent,
    NoContentPageComponent,
    NoContentPageComponent,
    NotFoundPageComponent,
    PolicyOverviewPageComponent,
    PortalTimeoutModalComponent,
    PremiumComponent,
    ReportPageComponent,
    ScheduleAPageComponent,
    TaxFormsPageComponent
  ],
  imports: [
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    BenefitsSharedFormsModule,
    BenefitsSharedModule,
    BrowserModule,
    HttpClientModule,
    ReactiveFormsModule,
    BenefitsSharedServicesModule.configure({
      sharedServicesEnvironmentType: AppEnvironment
    }),
    DXONgSwiftUiModule.forRoot({ analyticsService: GoogleAnalyticsService })
  ],
  providers: [
    {
      provide: AppEnvironment,
      useValue: environment
    },
    httpErrorInterceptorProviders,
    httpPolicyTokenInterceptorProviders,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: PortalTimeoutInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: FlagsInterceptor,
      multi: true
    },
    windowProvider
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent]
})
export class AppModule {}
